
        Component.define('youbuy-comparar-aba', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

// const $el    = $(el);

// if (localStorage.getItem('model')) {

//     let comparar = Array.from(JSON.parse(localStorage.getItem("model")));

//     if (comparar.length > 0) {
//         $el.show();

//         let compare = new Vue({
//             el: '#comparar',
//             delimiters: ['${', '}'],
//             data: {
//                 airplanes: null,
//             },
//             methods: {
//                 deleteComparar: function(id) {
//                     comparar = comparar.filter(function(value) {
//                         return value != id;
//                     });

//                     if (comparar.length == 0) {
//                         $el.hide();
//                     }

//                     compare.airplanes = compare.airplanes.filter(function(airplane, index) {
//                         if (comparar.includes(airplane.id)) {
//                             return airplane;
//                         }
//                     });

//                     localStorage.setItem('model', JSON.stringify(comparar));
//                 },
//             },
//         })

//         axios
//         .get(root + 'wsyoubuy')
//         .then(function(response) {
//             compare.airplanes = response.data.airplanes.filter(function(airplane, index) {
//                 if (comparar.includes(airplane.id)) {
//                     return airplane;
//                 }
//             });
//         });
//     }
// }

        });